export const KEEP_ALIVE_PING_TIME_IN_MILLISECONDS = 25000
